// All data returned from API calls for reports
import HTTP from '../../services/baseHttpSvc.js';
import moment from 'moment';

const state = {
  referralReport: []
};

const getters = {
  referralReport: state => state.referralReport
};

const actions = {
  getReferralReport(store, params) {
    let query = `rowcount=${params.rowcount}&offset=${params.offset}`;
    if (params.daysAgo && !Number.isNaN(params.daysAgo)) {
      let dt = moment().subtract(Number.parseInt(params.daysAgo), 'days');
      query = '&referralDate=' + dt.format('YYYY-MM-DD');
    }
    HTTP.get('/patients/reports/closedreferrals?' + query).then(response => {
      store.commit('setReferralReport', response.data);
    });
  }
};

const mutations = {
  setReferralReport(state, report) {
    state.referralReport = report;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
